<script>
// https://cdn.materialdesignicons.com/4.7.95/
export default {
    name: 'MaterialDesignIcon',
    props: {
        className: {
            type: String,
            required: true,
        },
        pxSize: {
            type: [ String, Number ],
            required: false,
            default: 18,
            // These optional sizes are already provided by MDI
            validator: ( value ) => [ 18, 24, 36, 48 ].indexOf( Number( value ) ) !== -1,
        },
        hasRightMargin: {
            type: Boolean,
            required: false,
            // Defaults to false so we have NO padding built in. If the parameter is included
            // the button will look like: <button> <mdiIcon/> Button Text here </button>
            default: false,
        },
    },
    // Returns a span element that looks like the following: ( assuming 'comment-text-outline' as this.className )
    // <span class="mdi mdi-comment-text-outline" style="margin-right: .5em;"/>
    render( createElement ) {
        return createElement( 'span', {
            class: [
                'mdi',
                `mdi-${ this.className }`,
                `mdi-${ this.pxSize }px`,
            ],
            ...this.hasRightMargin
                ? {
                    style: {
                        'margin-right': '.5em',
                    },
                }
                : {},
        } );
    },
};
</script>
